
import { computed, defineComponent, PropType } from 'vue'
import { requiredRule } from '@/modules/validations'
import BillingTemplatesBasicBillingTemplateFormPart from '@/components/billing-templates/form-parts/basic-billing-template.vue'
import BillingTemplatesEmailDeliveryPolicyFormPart from '@/components/billing-templates/form-parts/email-delivery-policy.vue'
import BillingTemplatesElectronicDeliveryPolicyFormPart from '@/components/billing-templates/form-parts/electronic-delivery-policy.vue'
import BillingTemplatesFormFieldDeliveryPolicyType from '@/components/billing-templates/form-fields/delivery-policy-type.vue'
import { GetAgreementBillingTemplate } from '@/modules/agreements'
import { DeliveryPolicyType } from '@/modules/billing-templates'

export default defineComponent({
    name: 'agreement-billing-info-form',
    components: {
        BillingTemplatesBasicBillingTemplateFormPart,
        BillingTemplatesEmailDeliveryPolicyFormPart,
        BillingTemplatesElectronicDeliveryPolicyFormPart,
        BillingTemplatesFormFieldDeliveryPolicyType
    },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Object as PropType<GetAgreementBillingTemplate>
        },
        organizationId: {
            type: String,
            required: true
        }
    },
    async setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            requiredRule,
            localModel,
            DeliveryPolicyType
            // onAddBillingTemplate
        }
    }
})
